module.exports = __webpack_public_path__ + "static/assets/9e7c72f56355363ee3ef28f3f17d3eb1.svg";